import { Avatar, Badge, Box, Button, Divider, Grid, Group, LoadingOverlay, MediaQuery, Menu, Modal, Paper, Text, Title, UnstyledButton, useMantineTheme } from "@mantine/core";
import { useClipboard, useDisclosure } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaDownload, FaFile, FaShare } from "react-icons/fa";
import { BadgeOrigin } from "../components/theme_paper";
import { GET_REPORT, DOWNLOAD_REPORT, GET_TEMPLATES } from "../services/reports";
import { groupBy, getEntityProfile } from "../utility/util";
import html2canvas from "html2canvas";
import JSZip from 'jszip'
import axios from "axios";

export default function Report({ type, companyId, ...others }){
  const [data, setData] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openImages, setOpenImages] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loadingDownloadImages, setLoadingDownloadImages] = useState(false);

  const [openPdfDownload, handlePdfDownload] = useDisclosure(false);

  const clipboard = useClipboard({ timeout: 500 });
  const { colorScheme } = useMantineTheme();

  const download = (format, headerTemplate = null) => {
    if(companyId){
      setLoading(true)
      DOWNLOAD_REPORT(type, companyId, format, {...others, headerTemplate})
      .then(({ file }) => {
        window.open(file.url);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false)
        showNotification({title: "Ops", message: err.message, color: 'red'});
      })
    }
  }

  const downloadImages = async () => {
    setLoadingDownloadImages(true)
    const zip = new JSZip();

    const elements : any = document.getElementsByClassName("to-download-birthday");
    for(let element of elements){
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL('image/png');
  
      const base64Data = imgData.slice(imgData.indexOf(',') + 1);
      zip.file(`${element.id}.png`, base64Data, { base64: true });
    }
    zip.generateAsync({ type: 'blob' }).then(content => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(content);
      link.download = 'birthdays.zip';
      link.click();
    });
    setLoadingDownloadImages(false);
  }

  const loadReport = () => {
    setLoading(true)
    GET_REPORT(type, companyId, others)
    .then(({ data, company }) => {
      setLoading(false)
      setData(data);
      setCompany(company);
    })
    .catch(err => {
      setLoading(false)
      showNotification({title: "Ops", message: err.message, color: 'red'});
    })
  }
  
  const loadTemplates = () => {
    GET_TEMPLATES("pdf", companyId)
    .then(({templates}) => {
      setTemplates(templates)
    })
    .catch(err => {
      showNotification({title: "Ops", message: err.message, color: 'red'});
    })
  }

  React.useEffect(() => {
    if(companyId){
      loadReport();
      loadTemplates();
    }
  }, [companyId, type]);

  return <>
    <MediaQuery smallerThan="sm" styles={{display: 'none'}}>
      <div>
        <div style={{padding: 30, fontSize: 32, color: '#FFFFFF', textAlign: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <div style={{flex: 0.1}}>
            {company?.image
            ? <img alt={company.name} src={company.image} style={{height: 75}} />
            : <Title color="gray" order={2}>{company?.name}</Title>}
          </div>
          <div style={{flex: 0.8}}>
            <Title style={{fontWeight: 'normal'}} align="center" p="md" color={colorScheme === 'dark' ? 'white' : 'black'}>
              {type === 'new_themes'
              ? `Novas Pautas ${moment((others.created || [])[0]).format("DD/MM/YYYY")} - ${moment((others.created || [])[1]).format("DD/MM/YYYY")}`
              : type === 'birthdays'
              ? `Parlamentares Aniversariantes: ${moment((others.range || [])[0]).format("DD/MM/YYYY")} - ${moment((others.range || [])[1]).format("DD/MM/YYYY")}`
              : type === 'tramitation'
              ? `Tramitação ${moment((others.period || [])[0]).format("DD/MM/YYYY")} - ${moment((others.period || [])[1]).format("DD/MM/YYYY")}`
              : `Agenda ${moment((others.period || [])[0]).format("DD/MM/YYYY")} - ${moment((others.period || [])[1]).format("DD/MM/YYYY")}`}
            </Title>
          </div>
          <div style={{flex: 0.1}}>
            <img alt="DMOC" src="/assets/dmoc/5.png" style={{height: 75, borderRadius: 5}} />
          </div>
        </div>
      </div>
    </MediaQuery>
    <MediaQuery largerThan="sm" styles={{display: 'none'}}>
      <div>
        <div style={{padding: '20px 40px', fontSize: 32, color: '#FFFFFF', textAlign: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
          <div>
            {company?.image
            ? <img alt={company.name} src={company.image} style={{height: 75}} />
            : <Title color="gray" order={2}>{company?.name}</Title>}
          </div>
          <div>
            <img alt="DMOC" src="/assets/dmoc/5.png" style={{height: 75, borderRadius: 5}} />
          </div>
        </div>
        <div>
          <Title style={{fontWeight: 'normal'}} align="center" p="md" color={colorScheme === 'dark' ? 'white' : 'black'}>
            {type === 'new_themes'
            ? `Novas Pautas ${moment((others.created || [])[0]).format("DD/MM/YYYY")} - ${moment((others.created || [])[1]).format("DD/MM/YYYY")}`
            : type === 'birthdays'
            ? `Parlamentares Aniversariantes: ${moment((others.range || [])[0]).format("DD/MM/YYYY")} - ${moment((others.range || [])[1]).format("DD/MM/YYYY")}`
            : type === 'tramitation'
            ? `Tramitação ${moment((others.period || [])[0]).format("DD/MM/YYYY")} - ${moment((others.period || [])[1]).format("DD/MM/YYYY")}`
            : `Agenda ${moment((others.period || [])[0]).format("DD/MM/YYYY")} - ${moment((others.period || [])[1]).format("DD/MM/YYYY")}`}
          </Title>
        </div>
      </div>
    </MediaQuery>

    <div style={{minHeight: `60vh`}}>
      <LoadingOverlay visible={loading} />
      {type === 'birthdays'
      ? (data?.items || []).length === 0 && <Title align="center" mt="lg" order={4}>Nenhuma aniversariante para o filtro estabelecido</Title>
      : (data?.themes || []).length === 0 && <Title align="center" mt="lg" order={4}>Nenhuma pauta para o filtro estabelecido</Title>}

      {
        type === 'agenda'
        ? groupBy(
          (data?.themes || []).sort((a,b) => a.events[0]?.start > b.events[0]?.start ? 1 : -1),
          (th: any) => th.events[0],
          "id"
        )
        .map(grouped => {
          return <div>
            {grouped[0] && <Box p="xl">
              <Title order={3} color={grouped[0].origin === "senado" ? "blue" : "green"}>{moment(grouped[0].start).format("DD/MM/YYYY HH:mm")} - {grouped[0].origin === "senado" ? "Senado Federal" : "Câmara dos Deputados"}</Title>
              <Title order={3}>{grouped[0].location}</Title>
              <Title order={3} color="gray">{grouped[0].title}</Title>
            </Box>}
            <Grid m="lg">
              {grouped[1].map(theme => renderTheme({theme, files: data.files}))}
            </Grid>
          </div>
        })
        : type === 'new_themes'
        ? groupBy((data?.themes || []).sort((a,b) => a.created_at > b.created_at ? 1 : -1), (th: any) => moment(th.created_at).format("YYYY-MM-DD"))
        .map(grouped => {
          return <div>
            {grouped[0] && <Title order={3} m="lg">{moment(grouped[0]).format("DD/MM/YYYY")}</Title>}
            <Grid m="lg">
              {grouped[1].map(theme => renderTheme({theme, files: data.files}))}
            </Grid>
          </div>
        })
        : type === 'birthdays'
        ? <Grid m="lg">
          {(data?.items || []).sort((a,b) => moment(a.birthday).format("MM-DD") > moment(b.birthday).format("MM-DD") ? 1 : -1).map(item => <>
            <Grid.Col md={3} sm={12}>
              <Paper shadow="md" p="sm">
                  {["senador", "deputado_federal"].includes(item.type) && <Group position="center" mb="sm">
                      <Avatar src={item.custom_image ?? item.image} />
                  </Group>}
                  <Title align='center' order={5}>{item.name}</Title>
                  {item.type !== "orgao" && <Text weight="bold" color={item.type === "senador" ? "blue" : "green"} align='center' size={13}>{getEntityProfile(item)} - {[item.company, item.uf].filter(nn => nn).join("/")}</Text>}
                  {item.birthday && <>
                    <Divider mt="sm" mb="sm" />
                    <Text align='center' size={13}>Nascimento: {moment(item.birthday).format("DD/MM/YYYY")}</Text>
                  </>}
              </Paper>
          </Grid.Col>
          </>)}
        </Grid>
        : <Grid m="lg">
          {(data?.themes || []).map(theme => renderTheme({theme, files: data.files}))}
        </Grid>
      }
    </div>

    <Group mt="lg" position="right">
      <Menu>
        <Menu.Target>
          <Button
            mr="xs"
            mb="xs"
            variant="outline"
            color="gray"
            rightIcon={<FaDownload />}
          >Exportar</Button>
        </Menu.Target>
        <Menu.Dropdown>
          {type === 'birthdays'
          ? [
            <Menu.Item
              color="green"
              onClick={() => { setOpenImages(true) }}
            >Imagens</Menu.Item>,
          ]
          : [
            <Menu.Item
              color="green"
              onClick={() => { download("excel") }}
            >Excel</Menu.Item>,
            <Menu.Item
              color="gray"
              onClick={() => {
                if(templates.length > 1){
                  handlePdfDownload.open()
                }else{
                  download("pdf");
                }
              }}
            >PDF</Menu.Item>,
            <Menu.Item
              color="blue"
              onClick={() => { download("docx") }}
            >Word</Menu.Item>,
          ]}
        </Menu.Dropdown>
      </Menu>
      <Button
        mr="xs"
        mb="xs"
        rightIcon={<FaShare />}
        onClick={() => {
          clipboard.copy(window.location);
          showNotification({
            title: "Pronto",
            color: 'blue',
            message: "Link de compartilhamento copiado!",
            autoClose: 2000
          })
        }}
      >Compartilhar</Button>
    </Group>

    <Modal size="xs" opened={openPdfDownload} onClose={handlePdfDownload.close}>
      <Title mb="md" order={5}>Selecione um template para exportar o PDF</Title>
      {templates.map(t => <Button
        mb="xs"
        variant="default"
        fullWidth
        onClick={() => {
          handlePdfDownload.close();
          download("pdf", t.view);
        }}
      >{t.title}</Button>)}
    </Modal>

    <footer style={{margin: 0, padding: 20, height: 'auto', fontFamily: 'Montserrat', fontSize: 14}}>
        <div style={{padding: 0, display: 'flex', flexDirection: 'row', alignItems: 'flex-end', color: '#4a4a4a', textAlign: 'center', backgroundRepeat: 'no-repeat'}}>
            <img alt="DMOC" style={{borderRadius: 10, visibility: 'hidden', height: '40px'}} src="assets/dmoc/5.png" />
            
            <div style={{flex: 1, padding: '0px 20px', fontSize: '12px'}}>
                {/* Data da emissão: #{(new Date()).toLocaleDateString("pt-BR")} */}
                {/* <br/> */}
                Emitido por <a rel="noreferrer" style={{color: '#4a4a4a'}} href="https://dmoc.com.br" target="_blank">dmoc.com.br</a>
            </div>

            <img alt="DMOC" style={{borderRadius: 10, height: '40px'}} src="/assets/dmoc/5.png" />
        </div>
    </footer>

    <Modal
      opened={openImages}
      onClose={() => setOpenImages(false)}
      size="1180px"
    >
      <Button loading={loadingDownloadImages} onClick={downloadImages}>Baixar Imagens</Button>

      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        {type === "birthdays" && (data?.items || [])
          .sort((a,b) => moment(a.birthday).format("MM-DD") > moment(b.birthday).format("MM-DD") ? 1 : -1)
          .map(item => {
            let proportion = 0.6;
            return <div style={{marginTop: 40}}>
              <div
                className="to-download-birthday"
                id={`${item.name.replace(/ |\./g, "_")}_${moment(item.birthday).format("DD_MM_YYYY")}`}
                style={{width: 1080 * proportion, height: 1350 * proportion, position: 'relative'}}>
                {
                  [
                    { src: '/assets/birthday/fundo.png', width: 1080, height: 1350 },
                    { src: '/assets/birthday/parte-azul.png', width: 1080, height: 1350 },
                    { src: '/assets/birthday/3-detalhes-de-cima.png', width: 1080, height: 1350 },
                    { src: '/assets/birthday/feliz.png', width: 1080, height: 1350 },
                    { src: '/assets/birthday/circulo-foto.png', width: 1080, height: 1350 },
                    (item.custom_image ?? item.image) && { src: item.custom_image ?? item.image, x: 264, y: 398, width: 530, height: 522, circle: true},
                    { src: '/assets/birthday/retangulo-do-nome.png', width: 1080, height: 1350 },
                    { src: company.image ?? "/assets/dmoc/1.png", x: 720, y: 1100, width: 300, height: 220, contain: true },
                  ].filter(nn => nn).map((item) => <DownloadImage
                    src={item.src}
                    style={{
                      position: 'absolute',
                      width: item.width * proportion,
                      height: item.height * proportion,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: "center top",
                      backgroundSize: item.contain ? "contain" : "cover",
                      ...(item.x ? {left: item.x * proportion} : {}),
                      ...(item.y ? {top: item.y * proportion} : {}),
                      borderRadius: item.circle ? 700 : 0,
                    }} />)
                }
                {
                  [
                    { text: `A ${company?.name} deseja felicidades, sucesso e saúde!`, x: 60, y: 120, height: 960, width: 960, size: 52, color: 'black', },
                    { text: `${item.type === "senador" ? "Sen." : "Dep."} ${item.name}`, x: 0, y: 890, height: 38, width: 1080, size: 32, color: 'black', weight: 'bold' },
                    { text: [item.company, item.uf].filter(nn => nn).join(" / "), x: 0, y: 932, height: 34, width: 1080, size: 28, color: 'black', },
                  ].map(item => <div
                    style={{
                      position: 'absolute',
                      top: item.y * proportion,
                      fontWeight: item.weight ?? "normal",
                      left: item.x * proportion,
                      width: item.width * proportion,
                      textAlign: 'center',
                      fontSize: item.size * proportion,
                      color: item.color,
                    }}
                  >
                    {item.text}
                  </div>)
                }
              </div>
            </div>
          })}
      </div>
    </Modal>
  </>;
};

const renderTheme = ({theme, files}) => <Grid.Col md={6} lg={4} sm={12}>
  <Paper shadow="lg" p="md">
    <Group grow>
      <Text weight="bold" style={{flex: 1}}>{theme.title}</Text>
      <BadgeOrigin {...theme} />
    </Group>
    <Divider mt="md" mb="md" />
    <Text>{theme.description}</Text>
    
    <Divider mt="md" mb="md" />
    <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
        <div style={{flex: 1, paddingRight: 10}}>
            <Text size="sm" color="gray">Situação: {theme.status?.title}{theme.status?.description && ` - ${theme.status?.description}`}</Text>
        </div>
        <Text size="xs" color="gray">{moment(theme.status?.created_at).format("DD/MM/YYYY HH:mm")}</Text>
    </div>
    <Divider />
    
    {theme.tramitations.map(tramitation => <>
        <Divider />
        <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
            <div style={{flex: 1, paddingRight: 10}}>
                <Text size="sm" color="gray">Tramitação: {tramitation.title}</Text>
            </div>
            <Text size="xs" color="gray">{moment(tramitation.created_at).format("DD/MM/YYYY HH:mm")}</Text>
        </div>
    </>)}
    <Divider />
    <div style={{padding: '10px 0', display: 'flex', flexDirection: 'row'}}>
        <div style={{flex: 1, paddingRight: 10}}>
            <Text size="sm" color="gray">Apresentação: {(theme.authors || []).map(a => a.name).join(", ")}</Text>
        </div>
        <Text size="xs" color="gray">{moment(theme.created_at).format("DD/MM/YYYY HH:mm")}</Text>
    </div>
    <Divider mt="md" mb="md" />

    <Badge
      color={{
        'favorable': 'green',
        'favorable-res': 'teal',
        'neutral': 'gray',
        'unfavorable-res': 'yellow',
        'unfavorable': 'red',
      }[theme.favorable] || 'blue'}
    >
      {theme.favorable 
        ? {
          'favorable': "Posicionamento Favorável",
          'favorable-res': "Posicionamento Favorável - com ressalvas",
          'neutral': "Posicionamento Neutro",
          'unfavorable-res': "Posicionamento Contra - com ressalvas",
          'unfavorable': "Posicionamento Contra"
        }[theme.favorable]
        : "Posicionamento à Definir" }
    </Badge>
    
    <Badge
        color={{
          'very-high': 'green',
          'high': 'teal',
          'medium': 'gray',
          'low': 'yellow',
          'very-low': 'red',
        }[theme.priority] || 'blue'}
    >{{
        'very-high': "Prioridade - Muito alta",
        'high': "Prioridade - Alta",
        'medium': "Prioridade - Média",
        'low': "Prioridade - Baixa",
        'very-low': "Prioridade - Muito baixa",
    }[theme.priority] || "Prioridade à Definir"}</Badge>

    <Divider mt="md" mb="md" />
    
    {(files || []).filter(f => f.theme === theme.id).length > 0 && <div>
      <Text mb="sm">Documentação:</Text>
      
      {(files || [])
      .filter(f => f.theme === theme.id)
      .map(file => <>
        <Divider mb="sm" mt="sm" />
        <UnstyledButton onClick={() => window.open(`/f/${file._id}`)}>
          <Group>
              <Avatar size={40} color="blue"><FaFile /></Avatar>
              <div style={{flex: 1}}>
                  <Text>{file.title}</Text>
                  <Text size="xs" color="dimmed">{file.fileType.title}</Text>
              </div>
          </Group>
        </UnstyledButton>
      </>)}
    </div>}
  </Paper>
</Grid.Col>

const DownloadImage = ({ src: srcParent, style }) => {
  const [src, setSrc] = useState<any>("");

  useEffect(() => {
    if(srcParent && srcParent.includes("http")){
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/auth/image/${encodeURIComponent(srcParent)}`;
      const imgElement = document.createElement('img');
      imgElement.crossOrigin = 'anonymous';
  
      imgElement.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = imgElement.width;
        canvas.height = imgElement.height;
        ctx.drawImage(imgElement, 0, 0);
  
        const base64data = canvas.toDataURL(apiUrl.includes(".png") ? 'image/png' : 'image/jpeg');
        console.log('Base64 Image:', base64data);
        setSrc(base64data);
      };

      imgElement.src = apiUrl;
      // fetch(apiUrl)
      // .then(response => {
      //   return response.blob();
      // })
      // .then(blob => {
      //   const reader = new FileReader();
      //   reader.readAsDataURL(blob);
      //   reader.onloadend = () => {
      //     const base64data = reader.result;
      //     setSrc(base64data);
      //   };
      // })
      // .catch(error => {
      //   setSrc(srcParent)
      //   console.error(`${srcParent}`, error);
      // });
    }else{
      setSrc(srcParent);
    }
  }, [srcParent])

  return <div
    style={{
      ...style,
      ...(src ? {
        backgroundImage: `url(${src})`,
      } : {})
    }}
  />;
}